module.exports = __webpack_public_path__ + "static/media/kappa-min.b523acdc.png";